require('./bootstrap');
import './libs/trix';
import Alpine from 'alpinejs';
//import './libs/iframeResizer.contentWindow.min';

window.Alpine = Alpine;
Alpine.start();
window.Tagify = require("@yaireo/tagify");
